import ApplyMessageActionRequest from 'owa-service/lib/contract/ApplyMessageActionRequest';
import ApplyMessageActionResponseMessage from 'owa-service/lib/contract/ApplyMessageActionResponseMessage';
import applyMessageActionOperation from 'owa-service/lib/operation/applyMessageActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import applyMessageActionRequest from 'owa-service/lib/factory/applyMessageActionRequest';
import messageAction from 'owa-service/lib/factory/messageAction';
import itemId from 'owa-service/lib/factory/itemId';

/**
 * Restore item service
 * @param itemIds the itemIds to be restored
 * @return the ApplyMessageActionResponseMessage
 */
export default function restoreItemService(
    itemIds: string[]
): Promise<ApplyMessageActionResponseMessage> {
    const requestBody = configureRequestBody(itemIds);

    return applyMessageActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}

/**
 * Configure the request body
 * @param itemIds the itemIds to be restored
 * @return the ApplyMessageActionResponseMessage body
 */
function configureRequestBody(itemIds: string[]): ApplyMessageActionRequest {
    return applyMessageActionRequest({
        MessageAction: messageAction({
            Action: 'Restore',
        }),
        Ids: itemIds.map(itemIdValue => itemId({ Id: itemIdValue })),
    });
}
